import { LeaseSpace, CreditReportType } from '@centecomm/portal-service';
import { createSelector } from 'reselect';
import { LoadStatus, State } from '../../Types';
import { Address, IdentificationType, BusinessInformation, PersonalInformation } from './Types';
import { FCRA } from './Types/FCRA';
import { LeasingApplication } from './Types/LeasingApplication';

const leasingState = ({ leasing }: State) => leasing;

export const applicationLoadStatus = createSelector(leasingState, ({ loadStatus }): LoadStatus => loadStatus);

export const leasingApplication = createSelector(
    leasingState,
    ({ application }): LeasingApplication | undefined => application,
);

export const leasingProperties = createSelector(leasingState, ({ properties }): LeaseSpace[] => properties);

export const leasingPropertiesLoaded = createSelector(leasingState, ({ propertiesLoaded }): boolean => propertiesLoaded);

export const creditReportType = createSelector(
    leasingState,
    ({ application }): CreditReportType | undefined => application?.creditReportType,
);

export const creditReportEnabled = createSelector(
    leasingState,
    ({ application }): boolean | undefined => application?.creditReportEnabled,
);

export const isApplicationStarted = createSelector(
    leasingState,
    ({ application }): boolean => !!application && application.started,
);

export const isApplicationPaused = createSelector(leasingState, ({ pause }): boolean => pause === true);

// Beginning Steps of Application
//   Personal Info, Address, Identity
const leasingApplicationState = createSelector(leasingState, ({ application }): LeasingApplication | undefined =>
    !!application ? application : undefined,
);

export const personalInformation = createSelector(
    leasingApplicationState,
    (application): PersonalInformation | undefined => application?.personalInformation,
);

export const businessInformation = createSelector(
    leasingApplicationState,
    (application): BusinessInformation | undefined => application?.businessInformation,
);

export const address = createSelector(leasingApplicationState, (application): Address | undefined => application?.address);

export const identification = createSelector(
    leasingApplicationState,
    (application): IdentificationType | undefined => application?.identification,
);

export const hasAcceptedFCRA = createSelector(leasingApplication, (application): boolean => !!application?.hasAcceptedFCRA);

export const fcra = createSelector(leasingApplication, (application): FCRA | undefined => application?.fcra);

export default {
    address,
    applicationLoadStatus,
    businessInformation,
    creditReportType,
    creditReportEnabled,
    fcra,
    hasAcceptedFCRA,
    identification,
    isApplicationPaused,
    isApplicationStarted,
    leasingApplication,
    personalInformation,
    leasingProperties,
    leasingPropertiesLoaded,
};
